<template>
  <div class="index">
    <div class="centered">
      <span class="button-wrapper add-user" @click="addNewAccount">
        <a class="button is-info">+</a>Создать пользователя панели администратора
      </span>
    </div>
    <div class="accounts">
      <AccountItem v-for="account in accountsData"
      :key="account.id"
      :account="account"
      :roles="roles"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AccountItem from 'components/Accounts/AccountItem'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Accounts',
  data () {
    return {
      newAccounts: []
    }
  },
  computed: {
    ...mapState(['accounts', 'roles']),
    accountsData () {
      return deepcopy(this.accounts)
    }
  },
  created () {
    this.getAccounts()
    this.getRoles()
  },
  methods: {
    ...mapActions(['getAccounts', 'getRoles', 'addAccountSchema']),
    addNewAccount () {
      const role = this.roles && this.roles[0] ? this.roles[0] : ''
      this.addAccountSchema({
        isNew: true,
        email: '',
        role: role,
        tempId: uuidv4()
      })
    }
  },
  components: { AccountItem }
}
</script>

<style scoped>
.add-user {
  margin-top: 40px;
}
.accounts {
  max-width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Index.vue?09fb4a8d